import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import { FC, ReactNode } from 'react';

interface IConfirmationDialogueProps extends DialogProps {
  customContent?: ReactNode;
  id: string;
  /**
   * A function to trigger on NO confirm.
   */
  onClose: () => void;
  /**
   * A function to trigger on YES confirm.
   */
  onConfirm: () => void;
  open: boolean;
  text?: string;
  title: string;
  hideCancel?: boolean;
}

/**
 * Presents an "Are you sure?" prompt with yes/no actions.
 */
export const ConfirmationDialogue: FC<IConfirmationDialogueProps> = ({
  customContent,
  id,
  onClose,
  onConfirm,
  open,
  text = 'Are you sure?',
  title,
  hideCancel = false,
  ...dialogProps
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onClose}
      aria-labelledby={`alert-dialog-${id}`}
      aria-describedby={`alert-dialog-${id}-description`}
      {...dialogProps}
    >
      <DialogTitle id={`alert-dialog-${id}`}>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-line' }} id={`alert-dialog-${id}-description`}>
          {text}
        </DialogContentText>
        {customContent}
      </DialogContent>

      <DialogActions>
        {!hideCancel && (
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
        )}
        <Button onClick={onConfirm} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
